import React, { useMemo } from "react";
import NativeSelect from "@material-ui/core/NativeSelect";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginBottom: theme.spacing() * 2,
    "&:not(:last-child)": {
      paddingRight: theme.spacing(),
    },
  },
  link: { color: "blue" },
}));

export default ({
  quantities,
  years,
  isPrint,
  getUpdateMethods,
  id,
  quantity,
  year,
  setName,
  cardNumber,
  playerName,
  parallel,
  cardValue,
  evaluationType,
  currencyCaption,
}) => {
  const classes = useStyles();

  const {
    removeCard,
    updateQuantity,
    updateYear,
    updateSetName,
    updateCardNumber,
    updatePlayerName,
    updateParallel,
    updateCardValue,
    updateCardEvaluationType,
  } = useMemo(
    () => (getUpdateMethods ? getUpdateMethods(id) : {}),
    [getUpdateMethods, id]
  );

  return (
    <Grid
      container
      style={{ breakInside: "avoid-page", pageBreakInside: "avoid" }}
    >
      <Grid item xs={12} md={1} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-quantity`}>Quantity</InputLabel>
          </Hidden>
          <NativeSelect
            id={`${id}-quantity`}
            value={quantity}
            onChange={updateQuantity}
            fullWidth
          >
            {(quantities || [quantity]).map((quantity) => (
              <option key={quantity} value={quantity}>
                {quantity}
              </option>
            ))}
          </NativeSelect>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={1} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-year`}>Year</InputLabel>
          </Hidden>
          <NativeSelect
            id={`${id}-year`}
            value={year}
            onChange={updateYear}
            fullWidth
          >
            {(years || [year]).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </NativeSelect>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-set-name`}>Set Name</InputLabel>
          </Hidden>
          <Input
            id={`${id}-set-name`}
            defaultValue={setName}
            onInput={updateSetName}
            maxLength={200}
            inputProps={{ autoComplete: "cc-csc" }}
            fullWidth
            required
            readOnly={!!isPrint}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={1} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-number`}>Card #</InputLabel>
          </Hidden>
          <Input
            id={`${id}-number`}
            defaultValue={cardNumber}
            onInput={updateCardNumber}
            maxLength={200}
            inputProps={{ autoComplete: "cc-csc" }}
            fullWidth
            required
            readOnly={!!isPrint}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={!isPrint ? 2 : 3} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-player-name`}>Player</InputLabel>
          </Hidden>
          <Input
            id={`${id}-player-name`}
            defaultValue={playerName}
            onInput={updatePlayerName}
            maxLength={200}
            inputProps={{ autoComplete: "cc-csc" }}
            fullWidth
            required
            readOnly={!!isPrint}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={1} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-parallel`}>Parallel</InputLabel>
          </Hidden>
          <Input
            id={`${id}-parallel`}
            defaultValue={parallel}
            onInput={updateParallel}
            maxLength={200}
            inputProps={{ autoComplete: "cc-csc" }}
            fullWidth
            readOnly={!!isPrint}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={1} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-card-value`}>
              Decl. {currencyCaption} Val
            </InputLabel>
          </Hidden>
          <Input
            id={`${id}-card-value`}
            defaultValue={cardValue}
            onInput={updateCardValue}
            maxLength={200}
            inputProps={{ autoComplete: "cc-csc" }}
            fullWidth
            required
            readOnly={!!isPrint}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2} className={classes.gridItem}>
        <FormControl fullWidth>
          <Hidden mdUp>
            <InputLabel htmlFor={`${id}-evaluation-type`}>Evaluate?</InputLabel>
          </Hidden>
          <NativeSelect
            id={`${id}-evaluation-type`}
            value={evaluationType}
            onChange={updateCardEvaluationType}
            fullWidth
          >
            <option value={0}>No</option>
            <option value={1}>Yes - Raw Card</option>
            <option value={2}>Yes - Slabbed Card</option>
          </NativeSelect>
        </FormControl>
      </Grid>
      {!isPrint ? (
        <Grid item xs={12} md={1} className={classes.gridItem}>
          <Hidden mdUp>
            <FormControlLabel
              control={
                <IconButton onClick={removeCard}>
                  <DeleteIcon />
                </IconButton>
              }
              label="Remove"
            />
          </Hidden>
          <Hidden smDown>
            <IconButton onClick={removeCard}>
              <DeleteIcon />
            </IconButton>
          </Hidden>
        </Grid>
      ) : null}
    </Grid>
  );
};
